import { Capacitor } from "@capacitor/core";

/**
 * Platform detection utilities for Capacitor
 */
export const Platform = {
  /** Running in native iOS or Android app */
  isMobile: Capacitor.isNativePlatform(),

  /** Running in iOS app */
  isIOS: Capacitor.getPlatform() === "ios",

  /** Running in Android app */
  isAndroid: Capacitor.getPlatform() === "android",

  /** Running in web browser */
  isWeb: Capacitor.getPlatform() === "web",

  /** Get current platform string */
  get platform() {
    return Capacitor.getPlatform();
  },
} as const;
